import React from "react";
import { Typography, Button } from "@mui/material";
import "./Connect.scss";
import { Link } from "react-router-dom";

const Connect: React.FC = () => {
    return (
        <div className="connect-page">
            <div className="content">
                <img
                    src="https://i.pinimg.com/564x/9e/a5/e5/9ea5e5255688e5a7a3a9c6226d36139c.jpg"
                    alt="Connect"
                    className="illustration"
                />
                <Typography variant="h4" className="title">
                    Connect
                </Typography>
                <Typography variant="body1" className="subtitle">
                    Become part of a thriving community and unlock new career opportunities.
                </Typography>
            </div>
            <div className="footer">
                <Link to="" className="skip-btn">
                    Skip
                </Link>
                <Button variant="contained" className="next-btn">
                    Next
                </Button>
            </div>
        </div>
    );
};

export default Connect;
